import * as React from "react";
import PropTypes from "prop-types";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import Collapse from "@material-ui/core/Collapse";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUp from "@material-ui/icons/KeyboardArrowUp";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";

class TListItem extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        icon: PropTypes.any,
        caption: PropTypes.string,
        subcaption: PropTypes.any,
        disabled: PropTypes.bool,
        primaryStyle: PropTypes.object,
        hasCollapse: PropTypes.bool,
        collapseItemsStyle: PropTypes.object,
        onClick: PropTypes.func,
        style: PropTypes.object,
        secondaryAction: PropTypes.any,
        smallCollapseArrows: PropTypes.bool,
        leftComponent: PropTypes.any,
    };

    static defaultProps = {
        icon: null,
        caption: "",
        subcaption: "",
        disabled: false,
        primaryStyle: {},
        hasCollapse: false,
        collapseItemsStyle: {},
        onClick: () => {},
        style: {},
        secondaryAction: null,
        smallCollapseArrows: false,
        leftComponent: null,
    };

    state = { open: false };

    //==================================================================================================================
    //
    //                                                 Events
    //
    //==================================================================================================================

    onClick = () => {
        this.props.onClick();
    };

    onCollapseClick = () => {
        this.setState({ open: !this.state.open });
    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    renderCollapseArrow = () => {
        const styles = {
            arrowSize: {
                height: "auto",
            },
        };

        if (this.props.smallCollapseArrows === true) {
            styles.arrowSize.height = 15;
        }

        if (this.state.open) {
            return <KeyboardArrowUp style={styles.arrowSize} />;
        } else {
            return <KeyboardArrowDown style={styles.arrowSize} />;
        }
    };

    render() {
        const styles = {
            secondary: {
                marginRight: 0,
            },
        };

        if (
            typeof this.props.secondaryAction === "string" ||
            typeof this.props.secondaryAction === "number" ||
            typeof this.props.secondaryAction === "boolean"
        ) {
            styles.secondary.marginRight = 15;
        }

        return (
            <div>
                <ListItem
                    button
                    onClick={this.props.hasCollapse ? this.onCollapseClick : this.onClick}
                    style={{ padding: "8px 16px 8px 24px", ...this.props.style }}
                    disabled={this.props.disabled}
                >
                    {this.props.leftComponent !== null ? this.props.leftComponent : null}

                    {this.props.icon !== null ? <ListItemIcon>{this.props.icon}</ListItemIcon> : null}

                    <ListItemText
                        disableTypography
                        primary={<Typography style={{ ...this.props.primaryStyle }}>{this.props.caption}</Typography>}
                        // primary={this.props.caption}
                        secondary={this.props.subcaption}
                        style={{ ...this.props.style }}
                    />

                    {this.props.hasCollapse ? this.renderCollapseArrow() : null}

                    <ListItemSecondaryAction style={styles.secondary}>
                        {typeof this.props.secondaryAction === "boolean"
                            ? this.props.secondaryAction
                                ? "true"
                                : "false"
                            : this.props.secondaryAction}
                    </ListItemSecondaryAction>
                </ListItem>

                <Collapse
                    in={this.state.open}
                    timeout="auto"
                    unmountOnExit
                    style={{ ...this.props.collapseItemsStyle }}
                >
                    {this.props.children}
                </Collapse>
            </div>
        );
    }
}

export default TListItem;
